import { HIDE_SEARCH_MODAL, SHOW_SEARCH_MODAL } from '../constants/actions';

const DEFAULT_SEARCH_MODAL_STATE = {
  show: false,
};

const searchModalReducer = (state = DEFAULT_SEARCH_MODAL_STATE, action) => {
  switch (action.type) {
    case HIDE_SEARCH_MODAL:
      return { ...state, show: false };
    case SHOW_SEARCH_MODAL:
      return { ...state, show: true };
    default:
      return state;
  }
};

export default searchModalReducer;
